<template>
  <form
    @submit.prevent="submitForm"
    class="flex flex-row flex-wrap px-4 mt-4 mb-4"
  >
    <div class="w-full flex flex-row flex-wrap mt-4">
      <div class="w-1/2 pr-4" :class="{ invalid: !name.isValid }">
        <label for="name">Name</label>
        <input
          type="text"
          id="name"
          v-model.trim="name.val"
          @blur="clearValidity('name')"
        />
        <p v-if="!name.isValid" class="text-xs">
          Name must not be empty.
        </p>
      </div>
      <div class="w-1/2 pl-4" :class="{ invalid: !username.isValid }">
        <label for="username">Username</label>
        <div
          v-if="mode == 'update'"
          class="border rounded-lg px-4 py-2 bg-gray-100"
        >
          {{ username.val }}
        </div>
        <input
          v-else
          type="text"
          id="username"
          v-model.trim="username.val"
          @blur="clearValidity('username')"
        />
        <p v-if="!username.isValid" class="text-xs">
          Username must not be empty.
        </p>
      </div>
      <div class="mt-4 w-1/2 pr-4" :class="{ invalid: !email.isValid }">
        <label for="email">Email (Optional)</label>
        <input
          type="email"
          id="email"
          v-model.trim="email.val"
          @blur="clearValidity('email')"
        />
        <p v-if="!email.isValid" class="text-xs">
          {{ email.msg }}
        </p>
      </div>
      <div class="mt-4 w-1/2 pl-4" :class="{ invalid: !phone.isValid }">
        <label for="phone">Phone (Optional)</label>
        <input
          type="text"
          id="phone"
          v-model.trim="phone.val"
          maxlength="10"
          @blur="clearValidity('phone')"
          @keypress="isNumber($event)"
        />
        <p v-if="!phone.isValid" class="text-xs">
          {{ phone.msg }}
        </p>
      </div>
      <div class="mt-4 w-1/2 pr-4" :class="{ invalid: !password.isValid }">
        <label for="password">Password</label>
        <input
          type="text"
          id="password"
          v-model.trim="password.val"
          @blur="clearValidity('password')"
        />
        <p v-if="!password.isValid" class="text-xs">
          Password must not be empty.
        </p>
      </div>
      <div v-if="mode == 'update'" class="mt-4 w-1/2 pl-4">
        <label for="status">Status</label>
        <select v-model.trim="status.val" id="status">
          <option value="1">Active</option>
          <option value="0">In Active</option>
        </select>
      </div>
      <div v-if="mode == 'update'" class="mt-4 w-1/2 pr-4">
        <label for="isLoggedIn">Login Status</label>
        <select v-model.trim="isLoggedIn.val" id="isLoggedIn">
          <option value="1">Logged In</option>
          <option value="0">Logged Out</option>
        </select>
      </div>
    </div>

    <h1 class="w-full text-lg font-medium mt-8">Commission & Balance Data</h1>
    <div
      class="w-full grid grid-cols-2 gap-8 mt-4 border p-8 rounded-xl shadow-lg"
    >
      <div class="w-full" :class="{ invalid: !openingBalance.isValid }">
        <label for="opening-balance">Opening Balance</label>
        <div v-if="mode == 'update'" class="border rounded-lg px-4 py-2 bg-gray-100">
          {{ openingBalance.val }} (Read-only)
        </div>
        <input
          v-else
          type="number"
          id="opening-balance"
          v-model.trim="openingBalance.val"
          min="0"
          @blur="clearValidity('openingBalance')"
        />
        <p v-if="!openingBalance.isValid" class="text-xs text-red-600">
          Opening Balance must not be empty.
        </p>
      </div>

      <div class="w-full" :class="{ invalid: !maxBalance.isValid }">
        <label for="max-balance">Max Balance (Branch Level)</label>
        <input
          type="number"
          id="max-balance"
          v-model.trim="maxBalance.val"
          min="0"
          step="0.01"
          @blur="clearValidity('maxBalance')"
        />
        <p v-if="!maxBalance.isValid" class="text-xs text-red-600">
          {{ maxBalance.msg }}
        </p>
      </div>

      <div class="w-full" :class="{ invalid: !payInCommissionPercentage.isValid }">
        <label for="pay-in-commission-percentage">Pay In Commission Percentage</label>
        <input
          type="number"
          id="pay-in-commission-percentage"
          v-model.trim="payInCommissionPercentage.val"
          min="0"
          step="0.01"
          @blur="clearValidity('payInCommissionPercentage')"
        />
        <p v-if="!payInCommissionPercentage.isValid" class="text-xs text-red-600">
          Pay In Commission Percentage must not be empty.
        </p>
      </div>

      <div class="w-full" :class="{ invalid: !payOutCommissionPercentage.isValid }">
        <label for="pay-out-commission-percentage">Pay Out Commission Percentage</label>
        <input
          type="number"
          id="pay-out-commission-percentage"
          v-model.trim="payOutCommissionPercentage.val"
          min="0"
          step="0.01"
          @blur="clearValidity('payOutCommissionPercentage')"
        />
        <p v-if="!payOutCommissionPercentage.isValid" class="text-xs text-red-600">
          Pay Out Commission Percentage must not be empty.
        </p>
      </div>
    </div>

    <div class="w-full flex flex-col justify-center items-center mt-8">
      <p v-if="!formIsValid" class="mb-4 text-red-600">
        Please fix the above errors and submit again.
      </p>
      <base-button
        ><span class="capitalize">{{ mode }}</span></base-button
      >
    </div>
  </form>
</template>

<script>
export default {
  emits: ["create-user"],
  props: ["mode", "selectedUser"],
  mounted() {
    if (this.mode == "update") {
      this.setUser();
    }
  },
  data() {
    return {
      name: {
        val: "",
        isValid: true,
        msg: "",
      },
      username: {
        val: "",
        isValid: true,
        msg: "",
      },
      email: {
        val: "",
        isValid: true,
        msg: "",
      },
      phone: {
        val: "",
        isValid: true,
        msg: "",
      },
      password: {
        val: "",
        isValid: true,
        msg: "",
      },
      status: {
        val: true,
        isValid: true,
        msg: "",
      },
      isLoggedIn: {
        val: false,
        isValid: true,
        msg: "",
      },
      openingBalance: {
        val: 0,
        isValid: true,
        msg: "",
      },
      maxBalance: {
        val: null,
        isValid: true,
        msg: "",
      },
      payInCommissionPercentage: {
        val: 0,
        isValid: true,
        msg: "",
      },
      payOutCommissionPercentage: {
        val: 0,
        isValid: true,
        msg: "",
      },
      formIsValid: true,
    };
  },
  methods: {
    clearValidity(input) {
      this[input].isValid = true;
      this[input].msg = "";
    },
    validateForm() {
      this.formIsValid = true;

      if (this.mode == "create") {
        if (this.username.val === "") {
          this.username.isValid = false;
          this.formIsValid = false;
        }
        if (this.password.val === "") {
          this.password.isValid = false;
          this.formIsValid = false;
        }
      }

      if (this.name.val === "") {
        this.name.isValid = false;
        this.formIsValid = false;
      }
      if (this.phone.val === "" && this.phone.val !== "") {
        this.phone.isValid = false;
        this.phone.msg = "Phone must not be empty.";
        this.formIsValid = false;
      } else if (this.phone.val.length > 0 && this.phone.val.length < 10) {
        this.phone.isValid = false;
        this.phone.msg = "Phone number must be 10 digits.";
        this.formIsValid = false;
      }
    },
    submitForm() {
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      let formData = {
        username: this.username.val,
        name: this.name.val,
        email: this.email.val,
        phone: this.phone.val,
        status: this.status.val,
        isLoggedIn: this.isLoggedIn.val,
        openingBalance: this.openingBalance.val,
        maxBalance: this.maxBalance.val,
        payInCommissionPercentage: this.payInCommissionPercentage.val,
        payOutCommissionPercentage: this.payOutCommissionPercentage.val,
      };

      if (this.mode == "create") {
        formData.password = this.password.val;
      } else {
        if (this.password.val != "") {
          formData.password = this.password.val;
        }
      }

      this.$emit("create-user", formData);
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setUser() {
      this.name.val = this.selectedUser.name;
      this.username.val = this.selectedUser.username;
      this.email.val = this.selectedUser.email;
      this.phone.val = this.selectedUser.phone;
      this.status.val = this.selectedUser.status;
      this.isLoggedIn.val = this.selectedUser.isLoggedIn;
      this.openingBalance.val = this.selectedUser.balance || 0;
      this.maxBalance.val = this.selectedUser.maxBalance || null;
      this.payInCommissionPercentage.val = this.selectedUser.payInCommission || 0;
      this.payOutCommissionPercentage.val = this.selectedUser.payOutCommission || 0;
    },
  },
};
</script>
